import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import blog1 from '../../images/blog1.jpg';
import blog2 from '../../images/blog2.jpg';
import blog3 from '../../images/blog3.jpg';

const Blog = () => {
    return (
        <Box sx={{ p: { xs: 2, sm: 2, md: 5 }, pb: 15, borderRadius: '10px' }} component={Paper} elevation={5}>
            <Box>
                <Typography variant='h6' sx={{ fontWeight: '700', fontSize: { xs: '18px', sm: '21px' }, color: 'primary.main' }}>Blog</Typography>
                <Typography variant='h4' sx={{ fontWeight: '700', fontSize: { xs: '25px', sm: '47px' } }}>Latest tips, tricks & <br /> Updates</Typography>
            </Box>

            <Box sx={{ pt: 8 }}>
                <Grid container spacing={4}>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={5} sx={{ borderRadius: '10px' }}>
                            <Box sx={{ height: { xs: 'auto', sm: '288px' } }}>
                                <img src={blog1} style={{ width: '100%', height: '100%', borderRadius: '10px 10px 0 0 ' }} alt="" />
                            </Box>
                            <Box sx={{ p: 3 }}>
                                <Typography variant='h4' sx={{ fontSize: '16px', color: 'primary.main', fontWeight: 700, mb: 1 }}>Category</Typography>
                                <Typography variant='h4' sx={{ fontSize: '21px', fontWeight: 700, }}>How to create a website using WordPress</Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={5} sx={{ borderRadius: '10px' }}>
                            <Box sx={{ height: { xs: 'auto', sm: '288px' } }}>
                                <img src={blog2} style={{ width: '100%', height: '100%', borderRadius: '10px 10px 0 0 ' }} alt="" />
                            </Box>
                            <Box sx={{ p: 3 }}>
                                <Typography variant='h4' sx={{ fontSize: '16px', color: 'primary.main', fontWeight: 700, mb: 1 }}>Category</Typography>
                                <Typography variant='h4' sx={{ fontSize: '21px', fontWeight: 700, }}>How to create a website using WordPress</Typography>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper elevation={5} sx={{ borderRadius: '10px' }}>
                            <Box sx={{ height: { xs: 'auto', sm: '288px' } }}>
                                <img src={blog3} style={{ width: '100%', height: '100%', borderRadius: '10px 10px 0 0 ' }} alt="" />
                            </Box>
                            <Box sx={{ p: 3 }}>
                                <Typography variant='h4' sx={{ fontSize: '16px', color: 'primary.main', fontWeight: 700, mb: 1 }}>Category</Typography>
                                <Typography variant='h4' sx={{ fontSize: '21px', fontWeight: 700, }}>How to create a website using WordPress</Typography>
                            </Box>
                        </Paper>
                    </Grid>

                </Grid>
            </Box>

        </Box>
    );
};

export default Blog;